import React, { FC } from 'react';
import styled from 'styled-components';
import { User } from 'api/models';
import { Avatar } from 'components/atoms/avatar';
import { ProductiveHeading05, Text03 } from 'components/styles';
import { fullName } from 'utils/full-name';
import { AvatarList } from './avatar-count-list';

interface TitleProps {
  $empty: boolean;
  $color: string;
}

const Title = styled.div<TitleProps>`
  ${ProductiveHeading05};
  ${Text03};
  ${({ $empty, $color }) => !$empty && `color: ${$color}`};

  a {
    color: inherit;
    ${({ $empty }) => $empty && 'pointer-events: none'};

    &:hover {
      text-decoration: underline;
    }
  }
`;

const Value = styled.a``;

interface Group {
  user: User;
  url: string;
  count: number;
}

interface Props {
  color: string;
  count: number;
  url: string;
  groups: Group[];
}

export const TasksCount: FC<Props> = ({ count, color, url, groups }) => {
  return (
    <>
      <Title $empty={count === 0} $color={color}>
        <Value href={url} target="_blank" rel="noopener noreferrer">
          {count}
        </Value>
      </Title>
      <AvatarList $color={color}>
        {groups.map(({ user, url: row_url, count: row_count }) => {
          return (
            <div key={user?.userId}>
              <Avatar
                name={fullName(user)}
                src={user?.photoUrl}
                companyLogoUrl={user?.company?.companyLogoUrl}
              />
              <a href={row_url} target="_blank" rel="noopener noreferrer">
                {row_count}
              </a>
            </div>
          );
        })}
      </AvatarList>
    </>
  );
};
